import { createAsyncThunk } from '@reduxjs/toolkit';
import { PricingParams, getPrice, PricingResponse } from './api';

export const fetchPrice = createAsyncThunk<PricingResponse, PricingParams>('pricing/fetch', async (params: PricingParams) => {
  const response = await getPrice(params);
  return response;
});
